export const newsletters = [
  {
    id: "february-march-2026",
    year: 2026,
    month: "February/March",
    displayDate: "February/March 2026",
    sortDate: "2026-03-01",
    title: "SNA Newsletter - February March 2026",
    file: "/newsletters/sna-newsletter-february-march-2026.pdf",
    fileName: "SNA Newsletter - February March 2026.pdf",
    sourcePdf: "SNB /Newsletter/10 SNA Newsletter - February March 2026.pdf",
    sha256: "d78025376d77e56cdc21e4d40cfed80f272041f1c0c008dd2ba951345c18e44e",
    unique: true,
  },
  {
    id: "january-2026",
    year: 2026,
    month: "January",
    displayDate: "January 2026",
    sortDate: "2026-01-01",
    title: "SNA Newsletter - January 2026",
    file: "/newsletters/sna-newsletter-january-2026.pdf",
    fileName: "SNA Newsletter - January 2026.pdf",
    sourcePdf: "SNB /Newsletter/9 SNA Newsletter - January 2026.pdf",
    sha256: "dc83693c52a7e6585f9b4e8e6d469f5cac611b0eeb70400e47683f39e31adfa7",
    unique: true,
  },
  {
    id: "december-2025",
    year: 2025,
    month: "December",
    displayDate: "December 2025",
    sortDate: "2025-12-01",
    title: "SNA Newsletter - December 2025",
    file: "/newsletters/sna-newsletter-december-2025.pdf",
    fileName: "SNA Newsletter - December 2025.pdf",
    sourcePdf: "SNB /Newsletter/8 SNA Newsletter - December 2025.pdf",
    sha256: "25ea154b5c29d538c93c631567337817b8a085c6c2bb41bf290ea02905ce5575",
    unique: true,
  },
  {
    id: "november-2025",
    year: 2025,
    month: "November",
    displayDate: "November 2025",
    sortDate: "2025-11-01",
    title: "SNA Newsletter - November 2025",
    file: "/newsletters/sna-newsletter-november-2025.pdf",
    fileName: "SNA Newsletter - November 2025.pdf",
    sourcePdf: "SNB /Newsletter/7 SNA Newsletter - November.pdf",
    sha256: "86bb65022cf3e741ffe4ff43c3d44376347b62b45c534df08c67725050464e99",
    unique: true,
  },
  {
    id: "october-2025",
    year: 2025,
    month: "October",
    displayDate: "October 2025",
    sortDate: "2025-10-01",
    title: "SNA Newsletter - October 2025",
    file: "/newsletters/sna-newsletter-october-2025.pdf",
    fileName: "SNA Newsletter - October 2025.pdf",
    sourcePdf: "SNB /Newsletter/6 SNA Newsletter - October.pdf",
    sha256: "bddb6bc8efa62558d87b13357c261ff07f69447159621d1735f1eb9fbfad728c",
    unique: true,
  },
  {
    id: "september-2025",
    year: 2025,
    month: "September",
    displayDate: "September 2025",
    sortDate: "2025-09-01",
    title: "SNA Newsletter - September 2025",
    file: "/newsletters/sna-newsletter-september-2025.pdf",
    fileName: "SNA Newsletter - September 2025.pdf",
    sourcePdf: "SNB /Newsletter/5 SNA Newsletter - September.pdf",
    sha256: "861635e131b817686a17acff4724d72ba6a5c6bb558e8b03ed5fb700c37f904e",
    unique: true,
  },
  {
    id: "august-2025",
    year: 2025,
    month: "August",
    displayDate: "August 2025",
    sortDate: "2025-08-01",
    title: "SNA Newsletter - August 2025",
    file: "/newsletters/sna-newsletter-august-2025.pdf",
    fileName: "SNA Newsletter - August 2025.pdf",
    sourcePdf: "SNB /Newsletter/4 SNA Newsletter - August.pdf",
    sha256: "bffe2b43aa35987c8b7522cf3d3ae653d6701f90258dd751ed52179d5b8b6e36",
    unique: true,
  },
  {
    id: "july-2025",
    year: 2025,
    month: "July",
    displayDate: "July 2025",
    sortDate: "2025-07-01",
    title: "SNA Newsletter - July 2025",
    file: "/newsletters/sna-newsletter-july-2025.pdf",
    fileName: "SNA Newsletter - July 2025.pdf",
    sourcePdf: "SNB /Newsletter/3 SNA Newsletter -July.pdf",
    sha256: "075ea66ead9da603512bd26eff5cffda6c45180265489d0de8cecd1160f90126",
    unique: true,
  },
  {
    id: "june-2025",
    year: 2025,
    month: "June",
    displayDate: "June 2025",
    sortDate: "2025-06-01",
    title: "SNA Newsletter - June 2025",
    file: "/newsletters/sna-newsletter-june-2025.pdf",
    fileName: "SNA Newsletter - June 2025.pdf",
    sourcePdf: "SNB /Newsletter/2 SNA Newsletter -June.pdf",
    sha256: "4003d071d37751854e6f89dc4f1dfc9bd805e1c5824399fddf94e6ba82e8f4ab",
    unique: true,
  },
  {
    id: "may-2025",
    year: 2025,
    month: "May",
    displayDate: "May 2025",
    sortDate: "2025-05-01",
    title: "SNA Newsletter - May 2025",
    file: "/newsletters/sna-newsletter-may-2025.pdf",
    fileName: "SNA Newsletter - May 2025.pdf",
    sourcePdf: "SNB /Newsletter/1 SNA Newsletter - May.pdf",
    sha256: "614325349c7d053d2d6838091d52e45e57f7b62553805f5c673d2a3026e1bcea",
    unique: true,
  },
];

export const sortedNewsletters = [...newsletters].sort((a, b) => new Date(b.sortDate) - new Date(a.sortDate));

export const newslettersByYear = sortedNewsletters.reduce((groups, issue) => {
  if (!groups[issue.year]) groups[issue.year] = [];
  groups[issue.year].push(issue);
  return groups;
}, {});

export const newsletterYears = Object.keys(newslettersByYear).map(Number).sort((a, b) => b - a);
